import { useState } from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Stack,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';

const ImagePreviewModal = ({ open, imageSrc, onApprove, onRetake, onClose }) => {
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 1.4));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.7));
  const handleRotateLeft = () => setRotation((prev) => prev - 90);
  const handleRotateRight = () => setRotation((prev) => prev + 90);

  const resetControls = () => {
    setZoom(1);
    setRotation(0);
  };

  return (
    <Dialog open={open} onClose={() => { onClose(); resetControls(); }}
      PaperProps={{
        sx: {
          width: '35vw',
          maxWidth: '40vw',
          height: '80vh',
          maxHeight: '75vh',
        },
      }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Preview</span>
        <IconButton onClick={() => { onClose(); resetControls(); }} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ height: '50vh', position: 'relative' }}>
        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          <Tooltip title="Zoom In">
            <IconButton onClick={handleZoomIn}><ZoomInIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Zoom Out">
            <IconButton onClick={handleZoomOut}><ZoomOutIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Rotate Left">
            <IconButton onClick={handleRotateLeft}><RotateLeftIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Rotate Right">
            <IconButton onClick={handleRotateRight}><RotateRightIcon /></IconButton>
          </Tooltip>
        </Stack>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto',
            height: '100%',
          }}
        >
          <img
            src={`data:image/png;base64,${imageSrc}`}
            alt="Preview"
            style={{
              transform: `scale(${zoom}) rotate(${rotation}deg)`,
              transition: 'transform 0.3s ease',
              width: '70%',
              // height:"70%",
              maxWidth: '100%',
              maxHeight: "100%",
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={onRetake}>Retake Photo</Button>
        <Button variant="contained" color="success" onClick={onApprove} autoFocus>
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImagePreviewModal;

